import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { closeDrawer } from "../../actions/drawerActions";
import IntegrationReviewHook from "../qd/integrations/IntegrationReviewHook";
import ArgoAppBarHook from "../common/ArgoAppBarHook";


function IntegrationReviewDrawerHook(props) {
    const dispatch = useDispatch();

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                handleCloseDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)

        return () => {document.removeEventListener("keydown", handleKeyDown, true)}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ClickAwayListener onClickAway={handleCloseDrawer}>
            <div style={{ height: "100%" }}>
                <ArgoAppBarHook
                    title="Review Integration"
                    showMenuArrowButton="LEFT"
                    onLeftIconButtonTouchTap={handleCloseDrawer}
                    isDrawer={true}
                    width={integrationReviewDrawerProps.width}
                />

                <div style={{ height: '64px' }}></div>

                <div>
                    <IntegrationReviewHook id={props.id} />
                </div>
            </div>
        </ClickAwayListener>
    );
}

IntegrationReviewDrawerHook.propTypes = {
    id: PropTypes.string
};

const integrationReviewDrawerProps = {
    opensecondary: true,
    width: "50%",
    docked: false,
    anchor: "right"
};

export default IntegrationReviewDrawerHook;
export { integrationReviewDrawerProps };